module.exports = __webpack_public_path__ + "img/unlimited-new.80096e0f.svg";